import toast, { Toast } from "react-hot-toast";
import i18n from "@assessment/i18n";

import GetHeroIcon from "../getHeroIcons";

export const showCustomToast = (messageKey: string) => {
  const title = i18n.t("assessment.toast.proctoringViolationDetected");
  const message = i18n.t(messageKey, { defaultValue: messageKey });

  toast.custom((_t: Toast) => {
    return (
      <div className="p-4 rounded-md bg-red-50">
        <div className="flex">
          <div className="shrink-0">
            <GetHeroIcon
              name="XCircleIcon"
              aria-hidden="true"
              className="text-red-400 size-5"
            />
          </div>
          <div className="mx-3">
            <h3 className="text-sm font-medium text-red-800">{title}</h3>
            <div className="my-2 text-xs text-red-700">
              <ul role="list" className="pl-5 space-y-1 list-disc">
                <li>{message}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  });
};
